/*eslint-env jquery*/
import React, { Component, useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { NavMenu } from './NavMenu'
import userTypes from '../../../_constants/userTypes'
import { Link } from 'react-router-dom'
import  config  from '../../../config'
import logo from '../../../assets/images/logo.png'
import { IoIosPower } from 'react-icons/io'
import { FaBars } from 'react-icons/fa'

import {
  Menu,
  Responsive,
  Sidebar,
  Visibility,
} from 'semantic-ui-react'
import { Container } from 'react-bootstrap'

import "imrc-datetime-picker/dist/imrc-datetime-picker.css"
// import 'semantic-ui-css/semantic.min.css'
import '../../../assets/css/semantic.rtl.min.css';
// import '@laylazi/bootstrap-rtl/dist/css/bootstrap-rtl.min.css';

class AdminLayout extends React.Component {


  // componentDidMount(){
  //   $(function(){
  //     $(".fa").bind('input propertychange',function(){
  //          if(!/^[پچجحخهعغفقثصضشسیبلاتنمکگوئدذرزطظژؤإأءًٌٍَُِّ\s\n\r\t\d\(\)\[\]\{\}.,،;\-؛]+$/.test($(this).val())){
  //              alert("فقط حروف فارسی مورد قبول است");
  //             $(this).val("");
  //          }
  //     });
  //     $(".email, .englishInput").bind('input propertychange',function(){
  //          if(/^[پچجحخهعغفقثصضشسیبلاتنمکگوئدذرزطظژؤإأءًٌٍَُِّ]+$/.test($(this).val())){
  //              alert("وارد کردن حروف فارسی برای این فیلد مجاز نیست");
  //             $(this).val("");
  //          }
  //     });
  //   });
  //   }

  render() {
    const { user, hideMenu } = this.props;
    return (

      <ResponsiveContainer user={user} hideMenu={hideMenu}>
        {this.props.children}
      </ResponsiveContainer>
    );
  }
}

function mapStateToProps(state) {
  const { authentication } = state;
  const { user } = authentication;
  return {
    user
  };
}

const connectedAdminLayout = connect(mapStateToProps)(AdminLayout);
export { connectedAdminLayout as AdminLayout };

const getWidth = () => {
  const isSSR = typeof window === 'undefined'

  return isSSR ? Responsive.onlyTablet.minWidth : window.innerWidth
}

const ResponsiveContainer = ({ children, user, hideMenu }) => (
  <>
    <Responsive minWidth={Responsive.onlyTablet.minWidth}>
      <DesktopContainer user={user} hideMenu={hideMenu}>{children}</DesktopContainer>
    </Responsive>
    <Responsive {...Responsive.onlyMobile}>
      <MobileContainer user={user} hideMenu={hideMenu}>{children}</MobileContainer>
    </Responsive>
  </>
)

class MobileContainer extends Component {
  state = {}

  componentDidMount() {
    document.querySelector('html').setAttribute('dir', 'rtl')
  }

  handleSidebarHide = () => this.setState({ sidebarOpened: false })

  handleToggle = () => this.setState({ sidebarOpened: true })

  render() {
    const { children, user, hideMenu } = this.props
    const { sidebarOpened } = this.state

    return (
      <Responsive
        as={Sidebar.Pushable}
        getWidth={getWidth}
        maxWidth={Responsive.onlyMobile.maxWidth}
      >
        <Sidebar
          animation='push'
          onHide={this.handleSidebarHide}
          visible={sidebarOpened}
        >
          <div className="mobile-menu">
            <NavMenu handleSidebarHide={this.handleSidebarHide} />
          </div>
        </Sidebar>

        <Sidebar.Pusher dimmed={sidebarOpened}>

        <div className={hideMenu ? "header red" : "header"}>

          {!hideMenu ?
            <Container>
              <Menu text style={{ margin: 0 }}>
                <Menu.Menu position='right'>
                  <Menu.Item onClick={this.handleToggle}>
                    <FaBars className="mdi" color='#fff'/>
                    {/* <Icon inverted name='sidebar' size='large' /> */}
                  </Menu.Item>

                  <Menu.Item fitted header style={{ minWidth: 80, padding: '0 20px' }}>
                    {user && user.travelBrand && user.travelBrand.logo ?
                      <img className="avatar-sm" src={config.uploadsUrl + user.travelBrand.logo} alt="" />
                      :
                      user && user.roleId === 1 ?
                        <img className="avatar-sm" src={logo} alt="" />
                        :
                        <img className="avatar-sm" src="/admin/images/default-avatar.png" alt="" />
                    }
                    <div className="user-fullname">
                      سیستم مدیریت خط تولید
                  <br />

                      {/* {user.name && user.name}
                  {user.surname && ' ' + user.surname} */}
                      <span>{user ? user.fullName : ''}</span>
                    </div>
                  </Menu.Item>
                </Menu.Menu>
                <Menu.Menu position='left' style={{width: '100%', justifyContent: 'flex-end'}}>
                <Menu.Item>
                <Link to="/login" ><IoIosPower color="#fff" size="30px" /></Link>
                </Menu.Item>
                  </Menu.Menu>
                <UserDropDown />
              </Menu>
            </Container>
  :
<div className="row">
              <div className="col-md-10 col-md-offset-1 col-sm-12">
                  <span className="shift-manager-user-fullname">
                    {(user && user.userType != undefined && userTypes.filter(el => el.value === user.userType)[0]) ?  userTypes.filter(el => el.value === user.userType)[0].label : ''}
                  {user ? ' (' + user.fullName + ')' : ''}
                  </span>
                <div className={hideMenu ? "text-left" : "pull-left"} style={{ padding: hideMenu ? "10px": "18px 10px 0 0" }}>
                  <Link to="/login" ><IoIosPower color="#fff" size="30px" /></Link>
                </div>
                </div>
                </div>
                }
  

          </div>

          <div className="row">
            <div className="col-md-10 col-md-offset-1">
            <div className={hideMenu ? "main-wrapper hideMenu" : "main-wrapper"}>
                {children}
              </div>
            </div>
          </div>

        </Sidebar.Pusher>
      </Responsive>
    )
  }
}

class DesktopContainer extends Component {
  state = { userFullName: '' }

  componentDidMount() {
    document.querySelector('html').setAttribute('dir', 'rtl')
    // document.querySelector('html').setAttribute('lang', 'ar')



  }

  hideFixedMenu = () => this.setState({ fixed: false })
  showFixedMenu = () => this.setState({ fixed: true })

  render() {
    const { children, user, hideMenu } = this.props
    const { fixed, userFullName } = this.state

    return (
      <Responsive getWidth={getWidth} minWidth={Responsive.onlyTablet.minWidth}>
        <Visibility
          once={false}
          onBottomPassed={this.showFixedMenu}
          onBottomPassedReverse={this.hideFixedMenu}
        >
          <div className={hideMenu ? "header red" : "header"}>

            <div className="row">
              <div className="col-md-10 col-md-offset-1 col-sm-12">
                {hideMenu ?
                  <span className="shift-manager-user-fullname">
                    {(user && user.userType != undefined && userTypes.filter(el => el.value === user.userType)[0]) ?  userTypes.filter(el => el.value === user.userType)[0].label : ''}
                  {user ? ' (' + user.fullName + ')' : ''}
                  </span>
                  :''}
                <div className={hideMenu ? "text-left" : "pull-left"} style={{ padding: hideMenu ? "10px": "18px 10px 0 0" }}>
                  <Link to="/login" ><IoIosPower color="#fff" size="30px" /></Link>
                </div>
                
                {!hideMenu &&
                <>
                <img className="avatar" src="/admin/images/default-avatar.png" alt="" />
                <div className="user-fullname">
                سیستم مدیریت خط تولید
    
                  <br />

                  {/* {user.name && user.name}
                  {user.surname && ' ' + user.surname} */}
                  <span>
                    {(user && user.userType != undefined && userTypes.filter(el => el.value === user.userType)[0]) ?  userTypes.filter(el => el.value === user.userType)[0].label : ''}
                  {user ? ' (' + user.fullName + ')' : ''}
                  </span>
                </div>
                </>
  }
              </div>
            </div>

          </div>
          {!hideMenu &&
          <div className="top-navbar" >
            <div className="row">
              <div className="col-md-10 col-md-offset-1">
                <div className="main-menu">
                  <NavMenu />
                </div>
              </div>
            </div>
          </div>
  }
        </Visibility>

        <div className="row">
          <div className="col-md-12">
            <div className={hideMenu ? "main-wrapper hideMenu" : "main-wrapper"}>
              {children}
            </div>
          </div>
        </div>
      </Responsive>
    )
  }
}

function UserDropDown() {

  return (
    <div>
    </div>
  )

}